export default {"src":"/_next/static/media/add_to_cart.9a1250c7.svg","height":23,"width":24};